import { ui } from '../../styles/ui'

export default function FormField({ label, error, helpText, htmlFor, className = '', children }) {
  return (
    <div className={`space-y-1 ${className}`.trim()}>
      {label ? <label htmlFor={htmlFor} className={ui.forms.label}>{label}</label> : null}
      {children}
      {error ? <p className={ui.forms.fieldError}>{error}</p> : null}
      {!error && helpText ? <p className={ui.forms.helpText}>{helpText}</p> : null}
    </div>
  )
}
